import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>CLA: de wonderpil om af te vallen?</title>
                <link rel="canonical" href={route("blogs.twenty-three")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – Personal Training Uden en Schijndel komt weer met een nieuwe blog. In deze blog gaan we het hebben over geconjugeerd linolzuur oftewel CLA. Dit populaire supplement wordt vaak gebruikt om extra gewicht te verliezen maar wat is er waar van deze theorie?"
                />
                <meta
                    property="og:description"
                    content="WE ARE – Personal Training Uden en Schijndel komt weer met een nieuwe blog. In deze blog gaan we het hebben over geconjugeerd linolzuur oftewel CLA. Dit populaire supplement wordt vaak gebruikt om extra gewicht te verliezen maar wat is er waar van deze theorie?"
                />
                <meta property="og:url" content={route("blogs.twenty-three")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="CLA: de wonderpil om af te vallen? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/cla.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <img
                                className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                src="/assets/blog/cla.jpg"
                                alt="CLA"
                            />
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        CLA: de wonderpil om af te vallen?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – Personal Training Uden en Schijndel komt weer
                        met een nieuwe blog. In deze blog gaan we het hebben
                        over geconjugeerd linolzuur oftewel CLA. Dit populaire
                        supplement wordt vaak gebruikt om extra gewicht te
                        verliezen maar wat is er waar van deze theorie?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is CLA?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        CLA is een meervoudige onverzadigde omega 6 vetzuur. Ze
                        zijn te vinden in zowel plantaardige als dierlijke
                        producten. Er zijn 28 soorten CLA die worden
                        onderscheiden door de verschillende dubbele binding die
                        elke vetzuur bevat. CLA is de afkorting van Conjugated
                        Linoleic Acid. Het is een essentieel vetzuur waardoor je
                        dit dient binnen te krijgen via je voeding of suppletie.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        In welke producten zit CLA?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        CLA zit in verschillende producten maar voornamelijk in
                        vlees en koemelk. Afhankelijk van hoe deze dieren hebben
                        geleefd is er een hoeveel CLA aanwezig in deze
                        producten. De gemiddelde inname van vrouwen ligt op 151
                        mg per dag en bij mannen op 212 mg per dag. CLA kan ook
                        worden gehaald uit supplementen. Deze vorm van CLA is
                        afkomstig uit plantaardige oliën.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is CLA de wonderpil?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoekers kwamen erachter dat CLA kon helpen om het
                        lichaamsvet te doen laten dalen. Onderzoek op muizen
                        laat zien dat CLA zorgt voor een lagere voedselinname,
                        een hogere vetverbranding en stimulatie voor afbraak van
                        vet (West, 2000). Op menselijke studies lieten veel
                        onderzoeken dit effect helaas niet tot nauwelijks zien.
                        Bij onderzoeken dat vetverlies vaststelde gebeurde dit
                        voornamelijk in de eerste vijf maanden waarbij 0,1 kg
                        per week wordt verloren. Hierdoor kunnen we concluderen
                        dat CLA geen wonderpil is en het opnieuw voornamelijk
                        aankomt op{" "}
                        <a
                            href={route("blogs.thirteenth")}
                            className="text-we-are-yellow"
                        >
                            bulken en cutten
                        </a>{" "}
                        met elkaar te wisselen om een atletisch lichaam te
                        realiseren.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Bestaat er überhaupt een wonderpil?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Supplementen blijven een toevoeging aan je dagelijkse
                        voeding. Supplementen zoals{" "}
                        <a
                            href={route("blogs.sixteenth")}
                            className="text-we-are-yellow"
                        >
                            omega 3 vetzuren
                        </a>
                        ,{" "}
                        <a
                            href={route("blogs.fifteenth")}
                            className="text-we-are-yellow"
                        >
                            creatine{" "}
                        </a>{" "}
                        en CLA kunnen bijdragen aan het complete plaatje maar
                        zijn niet het wondermiddel waar het omdraait.
                        Uiteindelijk is de basis: gezond eten en frequent
                        bewegen gecombineerd met een flinke dosis discipline het
                        geheim van een fysieke transformatie. Zorg er daarnaast
                        voor dat je genoeg{" "}
                        <a
                            href={route("blogs.tenth")}
                            className="text-we-are-yellow"
                        >
                            slaapt{" "}
                        </a>{" "}
                        en dat je{" "}
                        <a
                            href={route("blogs.fourth")}
                            className="text-we-are-yellow"
                        >
                            krachttraining{" "}
                        </a>{" "}
                        dominant aanwezig laat zijn in je trainingsschema.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        West, D. B. (2000, oktober 30). Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/11015475/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/11015475/{" "}
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
